import styled from '@emotion/styled';

import { getThemeColor } from '@ezugi/ui/theme';

export const Container = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: auto;
  overflow: hidden;
  font-weight: normal;
  color: ${getThemeColor('primaryContrast')};
  margin-bottom: 8px;
`;

export const Left = styled.div`
  display: flex;
  width: 50%;
  text-align: left;
  box-sizing: border-box;
  align-items: center;
  & > span {
    text-shadow: 1px 1px 1px #000;

    @media all and (orientation: portrait) {
      html[lang=ta] & {
        font-size: 11px;
      }
    }
  }
`;

export const Right = styled.div`
  display: flex;
  width: 50%;
  box-sizing: border-box;
  justify-content: flex-end;
  padding-right: 5px;
`;
